export default __webpack_public_path__ + "static/media/balmain-2.a174d6ee.jpg";